import React from 'react';
import { statusBadgeClass } from '../../utils/format';

export default function StatusBadge({ status }) {
  if (!status) return null;
  return <span className={statusBadgeClass(status)}>{status}</span>;
}
